var map = {
	"./hero_item_1.png": 5151,
	"./hero_slide_1.png": 6543,
	"./hero_slide_2.png": 5076,
	"./hero_slide_mobile_1.png": 7010,
	"./hero_slide_tablet_1.png": 1520,
	"./jacpots_user_image.png": 3559,
	"./livecas_image.png": 3654,
	"./slide_background_phone.png": 9562,
	"./slot_1.png": 8145,
	"./slot_2.png": 9162,
	"./slot_3.png": 4371,
	"./slot_4.png": 764,
	"./slot_5.png": 3829,
	"./slot_6.png": 2030,
	"./slot_7.png": 5047,
	"./slot_8.png": 4512,
	"./slot_9.png": 1417,
	"./slots.svg": 7796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7241;